// Maps print-service error_code values to i18n keys for user-friendly messages.
const PRINT_ERROR_I18N: Record<string, string> = {
  PRINTER_NOT_CONFIGURED: 'admin.printerNotConfigured',
  PRINTER_NOT_RESPONDING: 'admin.printerNotResponding',
  PRINT_RESULT_UNKNOWN: 'admin.printResultUnknown',
  STATION_SERVICE_DOWN: 'admin.stationServiceDown',
  ARP_LOOKUP_FAILED: 'admin.arpLookupFailed',
};

export function getPrintErrorMessage(
  t: (key: string) => string,
  errorCode?: string,
  errorFallback?: string,
  defaultMsg?: string,
): string {
  if (errorCode && PRINT_ERROR_I18N[errorCode]) {
    return t(PRINT_ERROR_I18N[errorCode]);
  }
  return errorFallback || defaultMsg || '';
}
